export default __webpack_public_path__ + "media/images/clock-f4ba48617eb9932bcb3477120ebc6531.svg";